import { BetterDocManualSearchBanner } from "@/modules/patients/detail/better-doc/components/better-doc-manual-search-banner"
import { DeBetterDocNoResultBanner } from "@/modules/patients/detail/better-doc/de/components/de-better-doc-no-result-banner"
import { DeBetterDocRecommendedCareProviders } from "@/modules/patients/detail/better-doc/de/components/de-better-doc-recommended-care-providers"
import { isBetterDocOffered } from "@/modules/patients/detail/better-doc/lib/is-better-doc-offered"
import { usePointOfCareBetterDocContext } from "@/modules/patients/detail/better-doc/point-of-care-better-doc-context"
import type { DeProgressNoteBetterDocResult } from "@/modules/patients/detail/better-doc/types"

type DeBetterDocResultProps = {
  betterDocResult: DeProgressNoteBetterDocResult | null
}

export const DeBetterDocResult = ({ betterDocResult }: DeBetterDocResultProps) => {
  const { betterDocUsage } = usePointOfCareBetterDocContext()

  if (betterDocResult?.kind === "CARE_PROVIDERS_RECOMMENDED") {
    return (
      <DeBetterDocRecommendedCareProviders
        key={betterDocResult.sessionId}
        recommendedCareProviders={betterDocResult.recommendedCareProviders}
      />
    )
  }

  if (betterDocResult?.kind === "MSN") {
    return <BetterDocManualSearchBanner data-testid="de-better-doc-msn-result" />
  }

  if (betterDocResult?.kind === "NO_RESULT" && isBetterDocOffered(betterDocUsage)) {
    return <DeBetterDocNoResultBanner />
  }

  return null
}
